import React from 'react';
import { translate } from 'react-i18next';
import { Layout, Checkbox } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'

import i18next from 'i18next';

import PaginationTop from 'Parts/search/PaginationTop';
import ResultTable from 'Parts/search/ResultTable';
import { simpleColumn, dateColumn, actionColumn } from 'Parts/common/columnUtils';
import Can from 'Parts/session/components/CanContainer';

import {
    RESOLVE_REPORT_SUCCESS
} from '../../messages/messageActions';

import SearchBar from 'Parts/search/SearchBarContainer';

import reportsEN from './locales/Reports_en.json';
import reportsFR from './locales/Reports_fr.json';

import './UserInbox.less';

class Reports extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            pager: {
                total: props.pagination.totalResults || 0,
                current: props.pagination.pageNumber || 1,
                pageSize: props.pagination.pageResults || 10
            }
        };

        i18next.addResourceBundle('en', 'Reports', reportsEN);
        i18next.addResourceBundle('fr', 'Reports', reportsFR);

        this.refresh = this.refresh.bind(this);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.markAsResolved = this.markAsResolved.bind(this);
    }

    componentDidUpdate(prevProps) {
        // Update the pager with the new total
        let pager;

        if (this.props.pagination.pageNumber !== prevProps.pagination.pageNumber || this.props.pagination.totalResults !== prevProps.pagination.totalResults
            || this.props.pagination.pageResults !== prevProps.pagination.pageResults
        ) {
            pager = {
                ...this.state.pager,
                total: this.props.pagination.totalResults || 0,
                current: this.props.pagination.pageNumber || 1,
                pageSize: this.props.pagination.pageResults || 10
            };

            this.setState({ pager });
        }
    }

    componentWillUnmount() {
        this.props.clearSearch();
    }

    handlePaginationChange = pager => {
        this.setState({ pager }, this.refresh);
    };

    render() {
        const {
            t,
            reports,
            pagination,
            locale,
            location
        } = this.props;
        const { pager } = this.state;

        return (
            <Layout className="ReportsListPage">
                <SearchBar
                    placeholder={t('Search')}
                    onSearch={this.handleSearch}
                    />
                <div className="chk-area">
                    <Checkbox 
                        id={'chk_show_resolved'}
                        initialValue={false}
                        onChange={this.handleCheckChange}
                    >{t('Show Resolved')}</Checkbox>
                </div>
                <Can
                    rules={[
                        ['roles.platform.SUPERADMIN']
                    ]}
                    redirect={`/${locale}/d`}
                >
                    <div className="AdminList">
                        <PaginationTop
                            totalLabel={total => t('reportsTotal', { count: pagination.totalResults })}
                            pager={pager}
                            onChange={this.handlePaginationChange}
                        />
                        <ResultTable
                            dataSource={reports}
                            pagination={pager}
                            onChange={this.handlePaginationChange}
                            showHeader={true}
                            columns={[
                                simpleColumn(t('Id'), 'id', null, true),
                                simpleColumn(t('Reporter Name'), 'reporter.name', null, true),
                                dateColumn(t('Reported on'), 'reportedOn', null, null, false, locale),
                                simpleColumn(t('Reason'), 'reason', null, true),
                                actionColumn(
                                t('Actions'),
                                null,
                                () => {},
                                report => {return (
                                    <span style={{display: 'flex', justifyContent: 'flex-end'}}>
                                        {!this.state.showResolved &&
                                            <button
                                                className="ant-btn ant-btn-circle"
                                                title={t('Mark as resolved')}
                                                onClick={() => {this.markAsResolved(report.id)}}
                                            >
                                                <FontAwesomeIcon icon={faCircleCheck} />
                                            </button>
                                        }
                                        <a
                                            className="ant-btn ant-btn-circle"
                                            href={location.pathname + "/" + report.id}
                                            title={t('View details')}
                                        >
                                            <FontAwesomeIcon icon={['fal', 'external-link']} />
                                        </a>
                                    </span>
                                )}
                                ),
                            ]}
                        />
                    </div>
                </Can>
            </Layout>
        );
    }

    handleCheckChange(e) {
        this.setState({
            showResolved: e.target.checked
        }, this.refresh)
    }

    handleSearch(e) {
       this.setState({search: e.search}, this.refresh)
    }

    markAsResolved(id) {
        this.props.resolveReport(id).then((e) => {
            if(e.type === RESOLVE_REPORT_SUCCESS)
                this.refresh();
        });
    }

    refresh() {
        const pagination = {
            pageResults: this.state.pager.pageSize,
            pageNumber: this.state.pager.current
        };
        this.props.searchFlaggedMessages(
            this.props.platformId,
            this.state.search,
            this.state.showResolved,
            pagination,
            { orderBy: 'addedOn[desc]' },
            true
        );
    }
}

Reports.defaultProps = {
  reports: [],
  pagination: {
    totalResults: 0,
    pageResults: 10
  }
};

export default translate('Reports')(Reports);